import { createReducer } from "deox";

import { ReusableRtpPayerResponse, SenderDataResponse } from "@APP/types";

import {
  clearReusableRtpState,
  setReusableRtpPayerInput,
  setReusableRtpSenderData,
  setReusableRtpSuccess,
} from "../actions";

export interface ReusableRtpState {
  reusableRtpData: ReusableRtpPayerResponse | null;
  /**
   * Supplier info from the sender-data endpoint. Persisted so company name
   * and orgId are available in InitiateRTPPaymentScreen after bank auth redirect.
   */
  senderData: SenderDataResponse | null;
  /**
   * User-entered amount for variable-amount RTPs. Null for fixed-amount RTPs.
   * Persisted so it survives the bank auth redirect.
   */
  payerEnteredAmount: string | null;
  /**
   * User-entered name. Empty string when requireCustomerName is false and
   * the payer left the field blank. Persisted so it survives the bank auth
   * redirect and is available in InitiateRTPPaymentScreen.
   */
  payerName: string | null;
  /**
   * Optional tip amount entered by the payer. Null when no tip was given or
   * tip is not allowed. Persisted so it survives the bank auth redirect.
   */
  payerTipAmount: string | null;
}

const defaultState: ReusableRtpState = {
  reusableRtpData: null,
  senderData: null,
  payerEnteredAmount: null,
  payerName: null,
  payerTipAmount: null,
};

const reusableRtpReducer = createReducer(defaultState, (handleAction) => [
  handleAction(setReusableRtpSuccess, (state, { payload }) => ({
    ...state,
    reusableRtpData: payload,
  })),
  handleAction(setReusableRtpSenderData, (state, { payload }) => ({
    ...state,
    senderData: payload,
  })),
  handleAction(setReusableRtpPayerInput, (state, { payload }) => ({
    ...state,
    payerEnteredAmount: payload.payerEnteredAmount,
    payerName: payload.payerName,
    payerTipAmount: payload.payerTipAmount,
  })),
  handleAction(clearReusableRtpState, () => ({ ...defaultState })),
]);

export default reusableRtpReducer;
